export class Queue {
  items: any[];
  pending: any[];
  status: string;
  constructor() {
    this.items = [];//用来存储元素。
    this.pending = [];
    this.status = 'free';
  }
  // 加入到队列
  enqueue(element) {
    if(Array.isArray(element)) {
      this.items = this.items.concat(element)
      return;
    }
    this.items.push(element);
  }
  // 从队列删除第一个元素
  dequeue() {
    return this.items.shift();
  }
  front() {
    return this.items[0];
  }
  isEmpty() {
    return this.pending.length === 0
  }
  // 查看队列的长度
  size() {
    return this.items.length
  }
  clear() {
    this.items = [];
    this.pending = [];
    this.status = 'ready';
  }
  getList() {
    return this.items;
  }
  do() {
    if (this.status === 'free' && this.pending.length) {
      this.status = 'pending';
      let unshiftData = this.pending.shift();
      this.items = this.items.map((item, i) => i === unshiftData.index ? unshiftData.item : item);
      this.status = 'free';
      this.do();
    }
  }
  pushPending(task) {
    this.pending.push(task);
    this.do();
  }
  update(index, newItem) {
    this.pushPending({
      index,
      item: newItem
    })
  }
}